export const mathInlineId = 'math_inline'

export const toggleLatexCommandName = 'ToggleLatex'
